<div class="card">
  <div class="card-body">
    <h5 class="card-title">Kappa Report Download</h5>
    <div class="description">
      Export a Kappa report for reconciled abstracts that were QC coded between the selected date range. The report includes:
      <ul>
        <li>Tabs for each activity code (mechanism) and type showing (1) the average kappa for each QC week and (2) the average weighted kappa for all QC weeks (in the specified date range).</li>
        <li>A final tab showing the raw kappa scores for each abstract included in the preceding tabs.</li>
      </ul>
    </div>
    <form *ngIf="kappaForm && weeks && years && mechanisms" [formGroup]="kappaForm" (ngSubmit)="onSubmit()">
      <div class="row my-3">
      </div>
      <div class="row">

        <!-- By FY/week radio group -->
        <div class="col-md-2">
          <label for="grantSelectionRadioGroup" class="h6">Grant Selection</label>
          <mat-radio-group name="grantSelectionRadioGroup" formControlName="isFy" (change)="toggleFY($event)">
            <mat-radio-button [value]="true">By FY</mat-radio-button>
            <mat-radio-button [value]="false">By Week</mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Start date drop down -->
        <div class="col-md-3">
          <label for="startDate" class="h6">{{isFy ? 'Starting FY' : 'From Week'}}</label>
          <mat-form-field floatLabel="never">
            <mat-select matNativeControl [class.small-text]="!isFy" name="startDate" formControlName="startDate" placeholder="Select">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let date of dates" [value]="date.value">{{date.text}}</mat-option>
            </mat-select>
            <mat-error *ngIf="kappaForm.get('startDate').hasError('required')">Start date is required.</mat-error>
            <mat-error *ngIf="kappaForm.get('startDate').hasError('invalidEndDate')"></mat-error>
          </mat-form-field>
        </div>

        <!-- End date drop down -->
        <div class="col-md-3">
          <label for="endDate" class="h6">{{isFy ? 'Ending FY' : 'To Week'}}</label>
          <mat-form-field floatLabel="never">
            <mat-select matNativeControl [class.small-text]="!isFy" name="endDate" formControlName="endDate" placeholder="Select">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let date of dates" [value]="date.value">{{date.text}}</mat-option>
            </mat-select>
            <mat-error *ngIf="kappaForm.get('endDate').hasError('required')">End date is required.</mat-error>
            <mat-error *ngIf="kappaForm.get('endDate').hasError('invalidEndDate')">End date may not be less than start date.</mat-error>
          </mat-form-field>
        </div>

        <!-- Mechanism checkboxes -->
        <div class="col-md-3">
          <label for="mechanisms" class="h6">Mechanism Type</label>
          <mat-form-field floatLabel="never">
            <mat-select formControlName="mechanisms" placeholder="Select" multiple>
              <mat-select-trigger *ngIf="all.selected">All</mat-select-trigger>
              <mat-option #all (onSelectionChange)="toggleAllMechanisms($event)" [value]="-1">Select All</mat-option>
              <mat-option (onSelectionChange)="uncheckSelectAllOnDeselect($event)" *ngFor="let m of mechanisms" [value]="m.id">{{m.mechanismType1}}</mat-option>
            </mat-select>
            <mat-error *ngIf="kappaForm.get('mechanisms').hasError('required')">At least one mechanism type must be selected.</mat-error>
          </mat-form-field>
        </div>

      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <!-- Kappa radio group -->
        <div class="col-md-9">
          <label for="kappaRadioGroup" class="h6">Kappa Type</label>
          <mat-form-field floatLabel="never">
            <mat-select formControlName="kappaType">
              @for(kappa of kappaOptions; track kappa){
              <mat-option [value]="kappa">
                {{kappa.kappaType1 }} - {{kappa.description}}
              </mat-option>}
            </mat-select>
          </mat-form-field>
        </div>

      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <button mat-button type="submit" class="btn" [ngClass]="kappaForm.valid ? 'btn-success' : 'btn-danger'">Run Report</button>
          <span class="ml-4">Kappa scores last updated for project: <strong>{{lastKappaDate}}</strong></span>
        </div>
      </div>
    </form>
  </div>
</div>
